"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/es.array.index-of.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Heading = exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireWildcard(require("react"));
var _hooks = require("@chakra-ui/hooks");
var _system = require("@chakra-ui/system");
var _useObservabilitySafe = require("../../hooks/useObservabilitySafe");
var _bricks = require("../../system/bricks.types");
var _utils = require("../../system/utils");
var _excluded = ["analyticsName", "trackImpression", "headingStyle", "as", "Component"],
  _excluded2 = ["as", "analyticsName"];
/* eslint-disable jsx-a11y/heading-has-content */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_nvx2l5u8j() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx";
  var hash = "1ab18cb39cdcc13964ce5b4937d004632d6d655b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx",
    statementMap: {
      "0": {
        start: {
          line: 44,
          column: 28
        },
        end: {
          line: 60,
          column: 2
        }
      },
      "1": {
        start: {
          line: 51,
          column: 20
        },
        end: {
          line: 51,
          column: 92
        }
      },
      "2": {
        start: {
          line: 52,
          column: 2
        },
        end: {
          line: 59,
          column: 4
        }
      },
      "3": {
        start: {
          line: 62,
          column: 23
        },
        end: {
          line: 90,
          column: 2
        }
      },
      "4": {
        start: {
          line: 63,
          column: 15
        },
        end: {
          line: 63,
          column: 55
        }
      },
      "5": {
        start: {
          line: 64,
          column: 17
        },
        end: {
          line: 64,
          column: 64
        }
      },
      "6": {
        start: {
          line: 65,
          column: 16
        },
        end: {
          line: 65,
          column: 73
        }
      },
      "7": {
        start: {
          line: 66,
          column: 27
        },
        end: {
          line: 66,
          column: 66
        }
      },
      "8": {
        start: {
          line: 66,
          column: 41
        },
        end: {
          line: 66,
          column: 55
        }
      },
      "9": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 80,
          column: 3
        }
      },
      "10": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 79,
          column: 6
        }
      },
      "11": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      },
      "12": {
        start: {
          line: 98,
          column: 51
        },
        end: {
          line: 100,
          column: 1
        }
      },
      "13": {
        start: {
          line: 99,
          column: 2
        },
        end: {
          line: 99,
          column: 49
        }
      },
      "14": {
        start: {
          line: 101,
          column: 51
        },
        end: {
          line: 103,
          column: 1
        }
      },
      "15": {
        start: {
          line: 102,
          column: 2
        },
        end: {
          line: 102,
          column: 49
        }
      },
      "16": {
        start: {
          line: 104,
          column: 51
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "17": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 105,
          column: 49
        }
      },
      "18": {
        start: {
          line: 107,
          column: 51
        },
        end: {
          line: 109,
          column: 1
        }
      },
      "19": {
        start: {
          line: 108,
          column: 2
        },
        end: {
          line: 108,
          column: 49
        }
      },
      "20": {
        start: {
          line: 110,
          column: 51
        },
        end: {
          line: 112,
          column: 1
        }
      },
      "21": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 111,
          column: 49
        }
      },
      "22": {
        start: {
          line: 113,
          column: 51
        },
        end: {
          line: 115,
          column: 1
        }
      },
      "23": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 114,
          column: 49
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 86
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 50
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 62,
            column: 54
          },
          end: {
            line: 62,
            column: 55
          }
        },
        loc: {
          start: {
            line: 62,
            column: 96
          },
          end: {
            line: 90,
            column: 1
          }
        },
        line: 62
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 66,
            column: 35
          },
          end: {
            line: 66,
            column: 36
          }
        },
        loc: {
          start: {
            line: 66,
            column: 41
          },
          end: {
            line: 66,
            column: 55
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 98,
            column: 51
          },
          end: {
            line: 98,
            column: 52
          }
        },
        loc: {
          start: {
            line: 99,
            column: 2
          },
          end: {
            line: 99,
            column: 49
          }
        },
        line: 99
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 101,
            column: 51
          },
          end: {
            line: 101,
            column: 52
          }
        },
        loc: {
          start: {
            line: 102,
            column: 2
          },
          end: {
            line: 102,
            column: 49
          }
        },
        line: 102
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 104,
            column: 51
          },
          end: {
            line: 104,
            column: 52
          }
        },
        loc: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 49
          }
        },
        line: 105
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 107,
            column: 51
          },
          end: {
            line: 107,
            column: 52
          }
        },
        loc: {
          start: {
            line: 108,
            column: 2
          },
          end: {
            line: 108,
            column: 49
          }
        },
        line: 108
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 110,
            column: 51
          },
          end: {
            line: 110,
            column: 52
          }
        },
        loc: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 49
          }
        },
        line: 111
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 113,
            column: 51
          },
          end: {
            line: 113,
            column: 52
          }
        },
        loc: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 114,
            column: 49
          }
        },
        line: 114
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 63,
            column: 15
          },
          end: {
            line: 63,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 63,
            column: 33
          },
          end: {
            line: 63,
            column: 43
          }
        }, {
          start: {
            line: 63,
            column: 46
          },
          end: {
            line: 63,
            column: 55
          }
        }],
        line: 63
      },
      "1": {
        loc: {
          start: {
            line: 64,
            column: 18
          },
          end: {
            line: 64,
            column: 41
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 18
          },
          end: {
            line: 64,
            column: 20
          }
        }, {
          start: {
            line: 64,
            column: 25
          },
          end: {
            line: 64,
            column: 40
          }
        }],
        line: 64
      },
      "2": {
        loc: {
          start: {
            line: 65,
            column: 50
          },
          end: {
            line: 65,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 65,
            column: 50
          },
          end: {
            line: 65,
            column: 54
          }
        }, {
          start: {
            line: 65,
            column: 58
          },
          end: {
            line: 65,
            column: 60
          }
        }],
        line: 65
      },
      "3": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 80,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 69
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1ab18cb39cdcc13964ce5b4937d004632d6d655b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nvx2l5u8j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_nvx2l5u8j();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/** bricks.opendoor.com/?path=/docs/core-heading */

var HeadingWithTracking = (cov_nvx2l5u8j().s[0]++, (0, _system.forwardRef)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    headingStyle = _ref.headingStyle,
    as = _ref.as,
    Component = _ref.Component,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_nvx2l5u8j().f[0]++;
  var inViewRef = (cov_nvx2l5u8j().s[1]++, (0, _useObservabilitySafe.useTrackComponentInView)('textViewEvent', trackImpression, analyticsName));
  cov_nvx2l5u8j().s[2]++;
  return /*#__PURE__*/_react["default"].createElement(Component
  // __css has a lower priority than sx
  , _extends({
    __css: headingStyle,
    ref: (0, _hooks.useMergeRefs)(inViewRef, ref)
  }, props));
}));
var Heading = exports.Heading = (cov_nvx2l5u8j().s[3]++, (0, _system.forwardRef)(function (_ref2, ref) {
  var _ref3, _ref4;
  var as = _ref2.as,
    analyticsName = _ref2.analyticsName,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_nvx2l5u8j().f[1]++;
  var size = (cov_nvx2l5u8j().s[4]++, 'size' in props ? (cov_nvx2l5u8j().b[0][0]++, props.size) : (cov_nvx2l5u8j().b[0][1]++, undefined));
  var asProp = (cov_nvx2l5u8j().s[5]++, (_ref3 = (cov_nvx2l5u8j().b[1][0]++, as)) !== null && _ref3 !== void 0 ? _ref3 : (cov_nvx2l5u8j().b[1][1]++, size));
  var style = (cov_nvx2l5u8j().s[6]++, (0, _utils.useStyleConfig)('Heading', _objectSpread({
    size: (_ref4 = (cov_nvx2l5u8j().b[2][0]++, size)) !== null && _ref4 !== void 0 ? _ref4 : (cov_nvx2l5u8j().b[2][1]++, as)
  }, props)));
  var HeadingComponent = (cov_nvx2l5u8j().s[7]++, (0, _react.useMemo)(function () {
    cov_nvx2l5u8j().f[2]++;
    cov_nvx2l5u8j().s[8]++;
    return (0, _bricks.bricks)(asProp);
  }, [asProp]));

  // Now that HeadingComponent is memoized this distinction shouldn't be necessary anymore
  cov_nvx2l5u8j().s[9]++;
  if (analyticsName) {
    cov_nvx2l5u8j().b[3][0]++;
    cov_nvx2l5u8j().s[10]++;
    return /*#__PURE__*/_react["default"].createElement(HeadingWithTracking, _extends({
      as: asProp,
      ref: ref,
      headingStyle: style,
      analyticsName: "".concat(analyticsName, "-").concat(asProp),
      Component: HeadingComponent
    }, props));
  } else {
    cov_nvx2l5u8j().b[3][1]++;
  }
  cov_nvx2l5u8j().s[11]++;
  return /*#__PURE__*/_react["default"].createElement(HeadingComponent
  // __css has a lower priority than sx
  , _extends({
    __css: style,
    ref: ref
  }, props));
}));

////////////////////////////////////////////////////////////////////////////////
// Shorthand aliases for the different heading levels.
////////////////////////////////////////////////////////////////////////////////
cov_nvx2l5u8j().s[12]++;
var H1 = exports.H1 = function H1(props) {
  cov_nvx2l5u8j().f[3]++;
  cov_nvx2l5u8j().s[13]++;
  return /*#__PURE__*/_react["default"].createElement(Heading, _extends({
    size: "UNSAFE_h1",
    as: "h1"
  }, props));
};
cov_nvx2l5u8j().s[14]++;
var H2 = exports.H2 = function H2(props) {
  cov_nvx2l5u8j().f[4]++;
  cov_nvx2l5u8j().s[15]++;
  return /*#__PURE__*/_react["default"].createElement(Heading, _extends({
    size: "UNSAFE_h2",
    as: "h2"
  }, props));
};
cov_nvx2l5u8j().s[16]++;
var H3 = exports.H3 = function H3(props) {
  cov_nvx2l5u8j().f[5]++;
  cov_nvx2l5u8j().s[17]++;
  return /*#__PURE__*/_react["default"].createElement(Heading, _extends({
    size: "UNSAFE_h3",
    as: "h3"
  }, props));
};
cov_nvx2l5u8j().s[18]++;
var H4 = exports.H4 = function H4(props) {
  cov_nvx2l5u8j().f[6]++;
  cov_nvx2l5u8j().s[19]++;
  return /*#__PURE__*/_react["default"].createElement(Heading, _extends({
    size: "UNSAFE_h4",
    as: "h4"
  }, props));
};
cov_nvx2l5u8j().s[20]++;
var H5 = exports.H5 = function H5(props) {
  cov_nvx2l5u8j().f[7]++;
  cov_nvx2l5u8j().s[21]++;
  return /*#__PURE__*/_react["default"].createElement(Heading, _extends({
    size: "UNSAFE_h5",
    as: "h5"
  }, props));
};
cov_nvx2l5u8j().s[22]++;
var H6 = exports.H6 = function H6(props) {
  cov_nvx2l5u8j().f[8]++;
  cov_nvx2l5u8j().s[23]++;
  return /*#__PURE__*/_react["default"].createElement(Heading, _extends({
    size: "UNSAFE_h6",
    as: "h6"
  }, props));
};
var _default = exports["default"] = Heading;